// extracted by mini-css-extract-plugin
module.exports = {"container":"video-module--container--1wLXK","video":"video-module--video--3QqYk"};